module.exports = __webpack_public_path__ + "img/card_2@3x.2b90d119.png";